import request from "@/utils/axios";

export function getImagefile(params) {
  return request({
    url: "/imagefile",
    method: "GET",
    params
  });
}

export function postUploadImg(data) {
  return request({
    url: "/uploadImg",
    method: "POST",
    data
  });
}

export function register(data) {
  return request({
    url: "api/mobile/mobileRegister",
    method: "POST",
    data
  });
}
export function login(data) {
  return request({
    url: "api/mobile/mobileLogin",
    method: "POST",
    data
  });
}
//打卡
export function clockIn(data) {
  return request({
    url: "api/mobile/workClockIn/v1/submit",
    method: "POST",
    data
  });
}
//打卡
export function clockIn2(data) {
  return request({
    url: "api/mobile/workSchedule/v1/submit",
    method: "POST",
    data
  });
}
//获取餐厅详情
export function getRestaurantDetail(params) {
  return request({
    url: "api/mobile/restaurant/v1/detail",
    method: "GET",
    params
  });
}
//获取餐厅详情2
export function getRestaurantDetail2(params) {
  return request({
    url: "api/mobile/restaurant/v2/detail",
    method: "GET",
    params
  });
}
//判断手机是否可以注册
export function isDeviceRegisterAble(data) {
  return request({
    url: "api/mobile/isDeviceRegisterAble",
    method: "POST",
    data
  });
}

//判断手机是否可以注册
export function getNoticeList(params) {
  return request({
    url: "api/mobile/notice/v1/list",
    method: "GET",
    params
  });
}
// 获取留言类型列表
export function getMsgTypeList(params) {
  return request({
    url: "api/mobile/messageType/v1/list",
    method: "GET",
    params
  });
}
// 上传拍照记录
export function submitPhoto(data) {
  return request({
    url: "api/mobile/photo/v1/save",
    method: "POST",
    data
  });
}
// 拍照记录
export function getPhotoList(params) {
  return request({
    url: "api/mobile/photo/v1/list",
    method: "GET",
    params
  });
}

// 提交留言
export function submitMessage(data) {
  return request({
    url: "api/mobile/message/v1/submit",
    method: "POST",
    data
  });
}
// 提交留言
export function getMessageList(params) {
  return request({
    url: "api/mobile/message/v1/list",
    method: "GET",
    params
  });
}

// 提交留言
export function workClockInList(params) {
  return request({
    url: "api/mobile/workClockIn/v1/list",
    method: "GET",
    params
  });
}
// 提交留言
export function workClockInList2(params) {
  return request({
    url: "api/mobile/workSchedule/v1/list",
    method: "GET",
    params
  });
}
// 提交留言
export function versioninfo(params) {
  return request({
    url: "api/mobile/version/v1/info",
    method: "GET",
    params
  });
}
// 身份证识别
export function recognizeIdCard(data) {
  return request({
    url: "api/mobile/isImageRecognizableForIdcard",
    method: "POST",
    data
  });
}
// 注销
export function mobileDeletion(data) {
  return request({
    url: "api/mobile/mobileDeletion",
    method: "POST",
    data
  });
}
// 扫码协助
export function supportRecordsubmit(data) {
  return request({
    url: "api/mobile/supportRecord/v1/submit",
    method: "POST",
    data
  });
}
// 扫码协助
export function initSupervisorQuestionaire(data) {
  return request({
    url: "api/mobile/supervisor/v1/initSupervisorQuestionaire",
    method: "POST",
    data
  });
}
// 扫码协助
export function reportLogs(data) {
  return request({
    url: "api/mobile/reportLogs",
    method: "POST",
    data
  });
}
// 拨打电话
export function getPhoneNumberFromPool(params) {
  return request({
    url: "api/mobile/customerService/v1/getPhoneNumberFromPool",
    method: "GET",
    params
  });
}
export function getSupervisorQuestionaire(params) {
  return request({
    url: "api/mobile/supervisor/v1/getSupervisorQuestionaire",
    method: "GET",
    params
  });
}
export function saveSupervisorQuestionaire(data) {
  return request({
    url: "api/mobile/supervisor/v1/saveSupervisorQuestionaire",
    method: "POST",
    data
  });
}
export function supervisorQuestionaireRestaurants(params) {
  return request({
    url: "api/mobile/supervisor/v1/supervisorQuestionaireRestaurants",
    method: "GET",
    params
  });
}
// 获取当前登录员工资料

export function mobileUserInfo(params) {
  return request({
    url: "api/mobile/mobileUserInfo",
    method: "GET",
    params
  });
}
// 判断员工今天有没有经理扫码

export function checkIfScanned(params) {
  return request({
    url: "api/mobile/supportRecord/v1/checkIfScanned",
    method: "GET",
    params
  });
}
// 获取当前登录员工是否为经理

export function checkIsSupervisor(params) {
  return request({
    url: "api/mobile/checkIsSupervisor",
    method: "GET",
    params
  });
}

// 获取通知id
export function updateCidToUser(data) {
  return request({
    url: "api/mobile/updateCidToUser",
    method: "POST",
    data
  });
}
// 评价
export function supportRecordevaluate(data) {
  return request({
    url: "api/mobile/supportRecord/v1/evaluate",
    method: "POST",
    data
  });
}
// 获取拨打客服通话记录
export function getCustomerServiceCalls(params) {
  return request({
    url: "api/mobile/supervisor/v1/getCustomerServiceCalls",
    method: "GET",
    params
  });
}

// 获取经理端留言列表

export function getSupervisorMessageList(params) {
  return request({
    url: "api/mobile/supervisor/v1/getSupervisorMessageList",
    method: "GET",
    params
  });
}
// 设置留言消息已读

export function updathandle(data) {
  return request({
    url: "api/admin/message/v1/handle",
    method: "POST",
    data
  });
}

// 获取经理端留言列表

export function getSupervisorEmployeeList(params) {
  return request({
    url: "api/mobile/supervisor/v1/getMobileList",
    method: "GET",
    params
  });
}

// 获取经理端留言列表

export function showPhone(params) {
  return request({
    url: "api/mobile/supervisor/v1/showPhone",
    method: "GET",
    params
  });
}
// 获取协助记录

export function getSupervisorRecordsList(params) {
  return request({
    url: "api/mobile/supportRecord/v1/getSupervisorRecordsList",
    method: "GET",
    params
  });
}
// 获取员工协助记录

export function getEmployeeRecordsList(params) {
  return request({
    url: "api/mobile/supportRecord/v1/getEmployeeRecordsList",
    method: "GET",
    params
  });
}
// 获取经理打卡记录

export function getSupervisorworkRuleList(params) {
  return request({
    url: "api/mobile/supervisor/v1/workRuleList",
    method: "GET",
    params
  });
}



// WEBPACK FOOTER //
// ./src/utils/api/common.js